class Monitoring.Models.Keyword extends Backbone.Model
  defaults:
    destroy: false

class Monitoring.Collections.KeywordsCollection extends Backbone.Collection
  model: Monitoring.Models.Keyword

  containsByName: (name) ->
    return @findByName(name) != null

  findByName: (name) ->
    keywords = @where({name: name, destroy: false})
    return if keywords.length > 0 then keywords[0] else null

  addKeyword: (keyword) ->
    existing_keyword = @where(name: keyword.get('name'))
    if existing_keyword.length > 0
      existing_keyword[0].set('destroy', false)
    else
      @add(keyword)

  removeByName: (name) ->
    keyword = @findByName(name)
    keyword.set('destroy', true)

  getActiveKeywords: ->
    @where(destroy: false)

  size: ->
    return @where({destroy: false}).length